import {ApolloClient} from 'apollo-client';
import {ApolloLink, concat} from 'apollo-link';
import {createUploadLink as createHttpLinkWithUploads} from 'apollo-upload-client';
import {InMemoryCache} from 'apollo-cache-inmemory';
import cookies from 'js-cookie';

const authMiddleware = new ApolloLink((operation, forward) => {
    operation.setContext({
        headers: {'X-CSRFToken': cookies.get('csrftoken')},
    });
    return forward(operation);
});

const httpLink = createHttpLinkWithUploads({
    uri: '/graphql/',
    credentials: 'same-origin',
});

const client = new ApolloClient({
    link: concat(authMiddleware, httpLink),
    cache: new InMemoryCache(),
});

export default client;



// WEBPACK FOOTER //
// ./graphql/client.js